import React from 'react'
import { Outlet } from 'react-router-dom'

const DashboardOutlet = () => {
    return (
        <div>
            <Outlet /> 
        </div>
    )
}

export default DashboardOutlet